"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const SoftAgeVerificationDisclaimerName =
  "Soft Age Verification Disclaimer";

export const disclaimerInputs = [
  {
    name: "content",
    type: "richText",
    required: true,
    defaultValue: "",
  },
] as const satisfies Inputs;

export const SoftAgeVerificationDisclaimerComponent: RegisteredComponent = {
  name: SoftAgeVerificationDisclaimerName,
  models: [getBuilderModelName("soft-age-verification")],
  component: dynamic(async () =>
    withValidation(
      disclaimerInputs,
      (await import("./Disclaimer")).Disclaimer,
      SoftAgeVerificationDisclaimerName
    )
  ),
  inputs: disclaimerInputs,
};
